export default __webpack_public_path__ + "static/media/screen1.17b07448.png";